"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactModal = require("@adsk/alloy-react-modal");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _modalContext = _interopRequireDefault(require("./modalContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ModalProvider = _ref => {
  let {
    children
  } = _ref;
  const [settings, setSettings] = (0, _react.useState)({
    isOpen: false
  });
  const onOpen = _ref2 => {
    let {
      title,
      message,
      confirmationButtonLabel,
      cancelButtonLabel,
      onConfirm,
      onCancel
    } = _ref2;
    setSettings({
      isOpen: true,
      title,
      message,
      confirmationButtonLabel,
      cancelButtonLabel,
      onConfirm,
      onCancel
    });
  };
  const onClose = () => {
    setSettings(settings => ({
      ...settings,
      isOpen: false
    }));
    settings.onCancel();
  };
  const {
    isOpen,
    title,
    message,
    cancelButtonLabel,
    confirmationButtonLabel,
    onConfirm
  } = settings;
  return /*#__PURE__*/_react.default.createElement(_modalContext.default.Provider, {
    value: {
      onOpen
    }
  }, /*#__PURE__*/_react.default.createElement(StyledConfirmationModal, {
    cancelButtonLabel: cancelButtonLabel,
    confirmationButtonLabel: confirmationButtonLabel,
    message: /*#__PURE__*/_react.default.createElement(Label, null, message),
    onClose: onClose,
    onConfirm: () => {
      setSettings(settings => ({
        ...settings,
        isOpen: false
      }));
      onConfirm();
    },
    show: isOpen,
    title: title,
    isConfirmationButtonAlert: false,
    size: "small"
  }), children);
};
ModalProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};
const Label = (0, _styledComponents.default)(_styledComponents.default.span(_alloyReactTheme.default.typography.labelMedium))`
  padding-left: 12px;
`;
const StyledConfirmationModal = (0, _styledComponents.default)(_alloyReactModal.ModalConfirmation)`
  [data-testid='ModalConfirmationHeader'] {
    min-height: auto;
  }
`;
var _default = exports.default = ModalProvider;